export interface IIndexedDbManager {
    /** Zaregistruje novou tabulku, která se vytvoří při vytváření nebo upgradu databáze */
    registerStore(storageName: string): void;
    getValue(storeName: string, name: string): Promise<any>;
    /** Získá všechny hodnoty v dané tabulce */
    getAllValues(storeName: string): Promise<any[]>;
    /** Vloží hodnotu pod daný klíč do dané tabulky */
    setValue(storeName: string, name: string, value: any): Promise<void>;
    /** Smaže všechny hodnoty ve všech tabulkách */
    clearAllValues(): Promise<void>;
    /** Smaže všechyn hodnoty v zadané tabulce */
    clearAllStoreValues(storeName: string): Promise<void>;
    /** Smaže celou databázi */
    deleteDb(): Promise<void>;
}
